import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

export const V2StudentLessonRun: React.FC = () => {
  const { runId } = useParams();
  const location = useLocation();
  const suffix = `${location.search || ''}${location.hash || ''}`;
  const target = runId ? `/v2/run/${runId}${suffix}` : `/v2/student${suffix}`;

  return <Navigate to={target} replace state={location.state} />;
};
